module.exports = __webpack_public_path__ + "static/feature-billables-cc69f1b43256b2832be70e1efdaf474e.png";